import React, { useState, useEffect } from "react";
// import CustomTable from '../../../../customComponents/CustomTable';
// import './index.scss';
// import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/api/API";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import searchIcon from "../../../../Assets/icons/searchicon.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import CustomTable from "../../../customComponents/CustomTable";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import download from "../../../../Assets/icons/download.svg";
import viewIcon from "../../../../Assets/icons/eye 1.svg";
import mailIcon from "../../../../Assets/icons/mailIcon.svg";
import * as base64 from "base-64";
import { showAlert } from "../../../customComponents/CustomSweetAlert/ShowAlert";
import Select from "react-select";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";

const SoldCustomerPurchaseOrder = () => {
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalInactive, setTotalInactive] = useState(0);
  const [dealerOption, setDealerOptions] = useState([]);
  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [filters, setFilters] = useState({});
  const [filterFormData, setFilterFormData] = useState({});
  const [actionTaken, setActionTaken] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const dealer_id = localStorage.getItem("dealerId");
  const userType = localStorage.getItem("UserType");

  useEffect(() => {
fetchProductList()
  },[])

  const fetchProductList = async (page = 0, pageSize = 10) => {
    try {
      
      const allfilteredData = filters;
   const payload = {
      orderBy: "postockinsr_id desc",
      page,
      pageSize,
      searchText: searchTerm,
      startDate: null,
      endDate: null,
      dealer_id:
        userType === "dealeruser"
          ? dealer_id
          : allfilteredData.dealerId || "0",
      checkCustomerTypeOrder: "E",

    };

      setLoading(true);
      const response = await axiosInstance.post(
        "/customer-po/list",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize,
        serial_no: item.serial_no || "--",
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setLoading(false);
    }
  };
  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchProductList();
  };
  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid 7BD755",
      boxShadow: "none",
      borderRadius: "20px",
      backgroundColor: "#fff",
      color: "#7BD755",
      width: "200px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "7BD755" : provided.backgroundColor,
      color: state.isFocused ? "black" : "#000",
    }),
  };
  //  const fetchActionTaken = async (page = 0, pageSize = 10) => {
  //   const allfilteredData = filters;
  //   try {
  //     setLoading(true);
  //     const response = await axiosInstance.post(
  //       "/purchaseorder/acceptlist",
  //       {
  //         orderBy: "po_id desc",
  //         page,
  //         pageSize,
  //         dealerId: allfilteredData.dealerId || null,
  //         // is_order_accepted: allfilteredData?.is_order_accepted
  //         //   ? allfilteredData?.is_order_accepted
  //         //   : "",
  //         // is_order_accepted:
  //         //   allfilteredData?.is_order_accepted === 0 ||
  //         //   allfilteredData?.is_order_accepted === "0"
  //         //     ? -1
  //         //     : allfilteredData?.is_order_accepted ?? 0,
  //         is_order_accepted: allfilteredData.is_order_accepted,
  //         searchText: searchTerm,
  //         poItemType:"V",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       },
  //     );

  //     const formattedData = response?.data?.data?.data?.map((item, index) => ({
  //       ...item,
  //       "Sr No.": index + 1,
  //       po_type: item.po_type || "- -",
  //       po_expected_date: item.po_expected_date || "--",
  //       po_delivery_date: item.po_delivery_date || "--",
  //       total: item.total || "--",
  //     }));

  //     const totalRecordsData = response?.data?.data?.totalRecords;
  //     const totalCount = response?.data?.data?.total;

  //     setTotalData(totalCount);

  //     console.log(totalRecordsData, "RECORDS");
  //     setTotalRecords(totalRecordsData);

  //     setActionTaken(formattedData);
  //     setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
  //   } catch (error) {
  //     console.error("Error fetching action taken list:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSearch = () => {
    const updatedFilters = {
      // is_order_accepted: filterFormData.is_order_accepted || 0,
      is_order_accepted:
        filterFormData.is_order_accepted !== undefined &&
        filterFormData.is_order_accepted !== null
          ? filterFormData.is_order_accepted
          : -1, // default All
      city: filterFormData.city_id || null,
      dealerId: filterFormData.dealerId || null,
    };

    setFilters(updatedFilters);
  };
  useEffect(() => {
    fetchProductList(0, 10);
  }, [filters]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductList(newPage);
  };

  const handleViewButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.VIEWCUSTOMERPURCHASEORDER}`, {
      state: { data: rowData },
    });
  };

const TABLE_HEADERS = [
  ...(userType === "businesspartner" ? ["Dealer Name"] : []),
  "Customer Name",
  "Mobile No.",
  "Delivery Date",
  "Final Price",
  "Action",
];

const keyMapping = {
  ...(userType === "businesspartner" && {
    "Dealer Name": "dealer_name",
  }),
  "Customer Name": "full_name",
  "Mobile No.": "mobile_no",
  "Delivery Date": "customer_delivery_date",
  "Final Price": "total_price",
  Action: [
    { type: "view", icon: viewIcon, label: "view" },
  ],
};

  useEffect(() => {
    if (searchTerm === "") {
      fetchProductList();
    }
  }, [searchTerm]);
  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITCUSTOMERPURCHASEORDER}`, {
      state: { data: rowData },
    });
  };

  // const DownLoadPdf = (row) => {
  //   console.log("row", row.postockinsr_id);
  //   var text = row?.postockinsr_id;
  //   var encoded = base64.encode(text);
  //   const pdfURL = `${process.env.REACT_APP_API_BASE_URL}customer-po/customer-wise-inovice/${encoded}`;
  //   window.open(pdfURL, "_blank", "noopener,noreferrer");
  // }

  const DownLoadPdf = async (row) => {
    try {
      var text = row?.postockinsr_id;
      var encoded = base64.encode(text);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}customer-po/customer-wise-inovice/${encoded}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
          },
        },
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `invoice_${row?.postockinsr_id}.pdf`; // file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const handleMailFunc = async (row) => {
    const text = row?.postockinsr_id;
    const encoded = base64.encode(text);

    try {
      const response = await axiosInstance.get(
        `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Email sent successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error fetching action taken list:", error);
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-6",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="OnboardManagamentContainer">
              <div className="OnboardManagamentbuttonContainer customer-purchase-order-heading">
                {/* <div style={{fontSize:"12px",color:"lightgrey"}} >Sales / Customer Purchase Order</div> */}
                <h5
                  className="customer-purchase-order-header"
                  style={{ fontWeight: "600" }}
                >
                  Customer Purchase Order
                </h5>
              </div>
              <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
                <button
                  className="addcustomerbutton"
                  onClick={() =>
                    navigate(
                      "/sales/manage-customer-purchase-order/sold-add-purchase-order",
                    )
                  }
                >
                  Add Existing Orders
                </button>
              </div>
            </div>
            <div className="tableWrapper">
              <div className="admin-list-container">
                <div className="listsearchContainer">
                  <h5 style={{ fontWeight: "600" }}>Order List</h5>
                  {/* <div>
                    <SearchInput
                      placeholder="Search Order"
                      onSearch={fetchProductList}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div> */}
                </div>
                {/* <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span>Select Dealer</span>
             <div className="filter-dropdown">
  <Select
    isClearable
    styles={customStyles}
    options={dealerOption}
    onChange={(option) => {
      setSelectedDealerId(option ? option.value : null);
      // Optionally, you can trigger a new fetch here based on the selected dealer
      // fetchProductList(0); // Reset to first page when dealer changes
    }}
    handleClear={clearFilter}
    placeholder="Select Dealer"
  />
</div>
 <button
  className="search-button"
  type="button"
  onClick={handleSearch}
  >
    Search
  </button>
            </div> */}
                <ListLogisticsFilters
                  formConfig={PhysicalStockTakingInputs}
                  formData={filterFormData}
                  setFormData={setFilterFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  handleSearch={handleSearch}
                  handleClear={clearFilter}
                />
              </div>
              <CustomTable
                data={productData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
                pdfDownLoad={DownLoadPdf}
                handleViewButton={handleViewButton}
                handleMailFunc={handleMailFunc}
                handleSearch={handleSearch}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SoldCustomerPurchaseOrder;
